import React, { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { useHistory } from "react-router-dom";
import { onMessageListener } from "./firebase";
import { showNotificationToast } from "utils/showNotificationToast";
import api from "components/api/api";
import { USER_NOTIFICATION_ROUTES } from "route";
import { seenNotificationIds } from "./notificationSeenStore";

const Notification = () => {
  const history = useHistory();

  useEffect(() => {
    onMessageListener()
      .then((payload) => {
        if (!payload) return;

        const data = payload.data || {};
        const notificationId = data.notificationId;

        if (!notificationId) return;
        if (seenNotificationIds.has(notificationId)) return;

        // 🔔 new unread → increment bell
        seenNotificationIds.add(notificationId);
        window.dispatchEvent(new Event("notifications:refresh"));

        showNotificationToast(
          {
            title: payload.notification?.title,
            message: payload.notification?.body,
            category: data.category,
            contentId: data.contentId,
          },
          async () => {
            try {
              // ✅ wait for backend
              await api.markNotificationAsRead(notificationId);

              // 🔔 now decrement bell correctly
              window.dispatchEvent(new Event("notifications:refresh"));

              history.push(
                `/${USER_NOTIFICATION_ROUTES[data.category]}?id=${data.contentId}`,
              );
            } catch (e) {
              console.error("Mark read failed", e);
            }
          },
        );
      })
      .catch((err) => console.error("FCM onMessage error", err));
  }, [history]);

  return <Toaster position="top-right" toastOptions={{ duration: 6000 }} />;
};

export default Notification;
